import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Role, Unit } from '../../models/unit';
import * as fromRoot from '../../../reducers';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromUnits from '../../reducers';
import {
  adminNavItems,
  recruiterNavItems,
  viewerNavItems,
} from './top-bar.config';
import { TranslateService } from '@ngx-translate/core';

interface Nav {
  title: string;
  url: string;
}

@Component({
  selector: 'mj-unit-top-bar',
  templateUrl: 'top-bar.component.html',
  styleUrls: ['top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitTopBarComponent implements OnInit, OnDestroy {
  public navItems: Nav[] = [];
  private currentUnit$: Subscription;

  constructor(
    private store: Store<fromUnits.State>,
    private translate: TranslateService
  ) {}

  private translateNavItems(navItems: any[]): any[] {
    return navItems.map(item => {
      this.translate.get(item.title_translation_key).subscribe(text => {
        item.title = text;
      });
      return item;
    });
  }

  ngOnInit() {
    this.currentUnit$ = this.store
      .select(fromRoot.getSelectedUnit)
      .subscribe((value: Unit) => {
        if (!value) {
          return;
        }
        if (value.role === Role.ADMIN || value.role === Role.GOD) {
          this.navItems = this.translateNavItems(adminNavItems);
        } else if (value.role === Role.RECRUITER) {
          this.navItems = this.translateNavItems(recruiterNavItems);
        } else if (value.role === Role.VIEWER) {
          this.navItems = this.translateNavItems(viewerNavItems);
        }
      });
  }

  ngOnDestroy() {
    this.currentUnit$.unsubscribe();
  }
}
